export default "__VITE_ASSET__CNEtWwX8__"